import Services from "./shared/services";
import Testimonials from "./shared/testimonials";
import Gallery from "./shared/gallery";

function Main() {
  return (
    <>
      <Services />
      <Testimonials />
      <Gallery />
    </>
  );
}

export default Main;
